module.exports = __webpack_public_path__ + "static/media/ami-logo-icon.dc93d18e.svg";